import session from 'redux-persist/lib/storage/session';
import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_AZURE, GET_AZURE_SUCCESS, GET_AZURE_ERROR, SESSION, SESSION_SUCCESS, SESSION_ERROR
} from './constant';


const initialState = {
  phase: INIT,
  azureList: null,
  error: null,
  session: null
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
export function AzureStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureList: action.data,
        error: null,
      };
    case GET_AZURE_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    case SESSION:
      return {
        ...state,
        phase: LOADING,
      };
    case SESSION_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        session: action.data,
        error: null,
      };
    case SESSION_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
